import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getAllDepartmentOfSale = async function() {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_GET_SALE_DEPARTMENT_BY_LEVEL + '?level=1');
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getTeamByDepartment = async function(departmentId) {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_CONTEXT_IN_CONTEXT_URL + departmentId);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getDetailContext = async function(contextId) {
            let result;
            try {
                const response = await this.$http.get(process.env.VUE_APP_CONTEXT_URL + contextId);
                if (response.data && response.data.success) {
                    result = response.data.data;
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };
    },
};